import React from 'react';

const ArticleSearchResultsNonFound = () =>
<div>
    No Articles Found
</div>;

ArticleSearchResultsNonFound.propType = {};

export default ArticleSearchResultsNonFound;